/**
 * THEODORE: keeps the ready-to-wear dispatch line in step with the chosen
 * variant (bug hunt #92).
 *
 * blocks/theodore-lead-time.liquid always prints the "In stock" line for a
 * ready-to-wear product and marks it `hidden` while the chosen variant is sold
 * out. Horizon re-renders only its own components when a size is picked, so
 * nothing touched that paragraph: it stayed beside a SOLD OUT button, and never
 * came back after a sold-out size. This listens for the same product select
 * event Horizon's own price and inventory components use and flips `hidden`.
 *
 * Loaded once on every page from snippets/scripts.liquid, not by the
 * block: the quick-add dialog morphs fetched product markup into a collection
 * page, where a script tag inside that markup never runs. One listener on the
 * document, no custom element and no imports, so it works on markup that
 * arrives later. Loading it twice is harmless.
 */
(() => {
  if (window.theodoreStockLineBound) return;
  window.theodoreStockLineBound = true;

  // StandardEvents.productSelect in @shopify/events.
  const PRODUCT_SELECT = 'shopify:product:select';

  document.addEventListener(PRODUCT_SELECT, (event) => {
    const picker = event.target;
    // A swatch on a product card selects that card's variant, not this product's.
    if (!(picker instanceof Element) || picker.closest('product-card')) return;

    const scope = picker.closest('.shopify-section, dialog');
    const pending = /** @type {{ promise?: Promise<{ detail?: any }> }} */ (event).promise;
    if (!scope || !pending) return;

    pending
      .then(({ detail }) => {
        if (!detail) return;

        // `resource` is the chosen variant, or null when the combination does not exist.
        const available = Boolean(detail.resource && detail.resource.available);

        for (const line of scope.querySelectorAll('[data-td-stock-line]')) {
          if (!(line instanceof HTMLElement)) continue;
          const lineProduct = line.dataset.productId;
          if (!detail.newProduct && detail.productId && lineProduct && detail.productId !== lineProduct) continue;
          line.hidden = !available;
        }
      })
      .catch(() => {
        // A newer selection aborts this one, and its own event carries the answer.
      });
  });
})();
